
import PermissionManager from "../permission/PermissionManage";
const hasPermi = (el, binding) => {
    const { value } = binding
    if(!PermissionManager.checkPermissioncustomMenu(value)){
        el.remove()
    }
}
 
export default hasPermi;